<template>
	<div class="add_backimgIndex">
		<div class="main_banner clearfix">
			<img src="@/images/main_banner.png" class="l" />
		</div>
		<div class="main_content">
			<div class="main_nav">
				教学团队
				<span class="r">
				首页>教学团队
			</span>
			</div>
			<div class="main_table">
				<div class="main_label ">院士介绍</div>
				<div class="team_teacher clearfix">
					<img src="@/images/team_teacherback.png" class="team_teacherback" />
					<div class="team_teacher_name">于金明</div>
					<div class="team_teacher_line"></div>
					<div class="team_teacher_text">
						于金明，中国工程院院士、医学博士、博士生导师，现任山东第一医科大学名誉校长、附属肿瘤医院院长，山东省人大常委会委员、科教文卫副主任，中央保健联系专家、中国临床肿瘤学会副理事长、中国抗癌协会副理事长、山东省抗癌协会理事长、山东省医学会肿瘤学分会主任委员、山东省院士专家联合会会长、山东省高层次人才促进会会长、中华肿瘤防治杂志等多家杂志主编或副主编。
					</div>
				</div>
				<div class="team_teacherinfos clearfix">
					<div class="team_teacherinfo_one">
						<div class="team_teacherinfo_line">
							基本信息
						</div>
						<div class="team_teacherinfo_text">
							性别：男
						</div>
						<div class="team_teacherinfo_text">
							年龄：65岁
						</div>
						<div class="team_teacherinfo_text">
							专业技术职务：教授
						</div>
						<div class="team_teacherinfo_text">
							学位：博士
						</div>
						<div class="team_teacherinfo_text">
							邮箱：sdyujinming@126.com
						</div>
					</div>
					<div class="team_teacherinfo_two">
						<div class="team_teacherinfo_line">
							工作经历
						</div>
						<div class="team_teacherinfo_times">
							<div class="team_teacherinfo_time">
								1983.07至1988.10 &nbsp; &nbsp; &nbsp; 山东省肿瘤防治研究院 副主任医师
							</div>
							<div class="team_teacherinfo_time">
								1988.10至1992.10 &nbsp; &nbsp; &nbsp; 美国弗吉尼亚大学医学院肿瘤中心 副教授
							</div>
							<div class="team_teacherinfo_time">
								1992.10至1995.04 &nbsp; &nbsp; &nbsp; 山东省肿瘤防治研究院 主任、副研究员
							</div>
							<div class="team_teacherinfo_time">
								1995.04至2001.03 &nbsp; &nbsp; &nbsp; 山东省肿瘤防治研究院 副院长、研究员
							</div>
							<div class="team_teacherinfo_time">
								1997.04至1997.09 &nbsp; &nbsp; &nbsp; 美国哈佛大学肿瘤中心 教授
							</div>
							<div class="team_teacherinfo_time">
								2004.07至今 &nbsp; &nbsp; &nbsp; 山东省肿瘤防治研究院 院长、研究员
							</div>
						</div>
					</div>
					<div class="team_teacherinfo_three">
						<div class="team_teacherinfo_line">
							主要职责
						</div>
						<div class="team_teacherinfo_text">
							虚拟仿真实验中心主任的主要职责是全面负责虚拟仿真实验中心的建设与管理工作。包括组织中心的建设规划、长期和年度工作计划制定；组织中心各线下各实验室之间的资源整合、知识共享，协调校内外相关资源，服务于实验室建设；提出中心师资培养计划，根据中心发展需要，组织与中心实验教学、科研任务相适应的学术梯队等队伍建设。
						</div>
					</div>
					<div class="team_teacherinfo_four">
						<div class="team_teacherinfo_line">
							教研科研主要成果
						</div>
						<div class="team_teacherinfo_text">
							主讲《癌症与癌症治疗的起源与发展》、《肿瘤学新进展》等课程。主持国家科技部重大专项、国自然重点项目、国家863项目等国家级项目11项。近三年发表SCI论文108篇，累计影响因子794.7分，其中10分以上20篇。为首或为主获国家科技进步二等奖3项、省最高奖、全国创新争先奖、何梁何利奖各1项，省部级一等奖8项。获山东省优秀博士论文指导教师、山东省教学成果奖等称号。
						</div>
					</div>
				</div>
			</div>
			<div class="main_table">
				<div class="main_label ">本中心教师基本情况</div>
				<table border="1" cellspacing="5" cellpadding="5">
					<tr>
						<td rowspan="3">
							<div class="main_tableP1">本中心教师基本情况</div>
						</td>
						<td>
						</td>
						<td>
							<div class="main_tableP2">正高</div>
						</td>
						<td>
							<div class="main_tableP2">副高</div>
						</td>
						<td>
							<div class="main_tableP2">中级</div>
						</td>
						<td>
							<div class="main_tableP2">其它</div>
						</td>
						<td>
							<div class="main_tableP2">博士</div>
						</td>
						<td>
							<div class="main_tableP2">硕士</div>
						</td>
						<td>
							<div class="main_tableP2">学士</div>
						</td>
						<td>
							<div class="main_tableP2">其它</div>
						</td>
						<td>
							<div class="main_tableP2">专职</div>
						</td>
						<td>
							<div class="main_tableP2">总人数</div>
						</td>
						<td>
							<div class="main_tableP2">平均年龄</div>
						</td>
					</tr>
					<tr>
						<td>
							<div class="main_tableP2">人数</div>
						</td>
						<td>
							<div class="main_tableP3">12</div>
						</td>
						<td>
							<div class="main_tableP3">17</div>
						</td>
						<td>
							<div class="main_tableP3">17</div>
						</td>
						<td>
							<div class="main_tableP3">0</div>
						</td>
						<td>
							<div class="main_tableP3">34</div>
						</td>
						<td>
							<div class="main_tableP3">8</div>
						</td>
						<td>
							<div class="main_tableP3">4</div>
						</td>
						<td>
							<div class="main_tableP3">0</div>
						</td>
						<td>
							<div class="main_tableP3">43</div>
						</td>
						<td rowspan="2">
							<div class="main_tableP3">46</div>
						</td>
						<td rowspan="2">
							<div class="main_tableP3">42.91</div>
						</td>
					</tr>
					<tr>
						<td>
							<div class="main_tableP3">占总人数比例</div>
						</td>
						<td>
							<div class="main_tableP3">26.09%</div>
						</td>
						<td>
							<div class="main_tableP3">36.96%</div>
						</td>
						<td>
							<div class="main_tableP3">36.96%</div>
						</td>
						<td>
							<div class="main_tableP3">0</div>
						</td>
						<td>
							<div class="main_tableP3">73.91%</div>
						</td>
						<td>
							<div class="main_tableP3">17.39%</div>
						</td>
						<td>
							<div class="main_tableP3">8.70%</div>
						</td>
						<td>
							<div class="main_tableP3">0</div>
						</td>
						<td>
							<div class="main_tableP3">93.48%</div>
						</td>
					</tr>
				</table>
			</div>
			<div class="main_table">
				<div class="main_label ">中心人员信息表</div>
				<table border="1" cellspacing="5" cellpadding="5">
					<tr>
						<td>
							<div class="main_tableP2">序号</div>
						</td>
						<td>
							<div class="main_tableP2">姓名</div>
						</td>
						<td>
							<div class="main_tableP2">年龄</div>
						</td>
						<td>
							<div class="main_tableP2">学位</div>
						</td>
						<td>
							<div class="main_tableP2">专业技术职务</div>
						</td>
						<td>
							<div class="main_tableP2">承担教学/管理任务</div>
						</td>
						<td>
							<div class="main_tableP2">专职/兼职</div>
						</td>
					</tr>
					<tr v-for="(item,index) in dataList1">
						<td>
							<div class="main_tableP3">{{index + 1}}</div>
						</td>
						<td>
							<div class="main_tableP3">{{item.data1}}</div>
						</td>
						<td>
							<div class="main_tableP3">{{item.data2}}</div>
						</td>
						<td>
							<div class="main_tableP3">{{item.data3}}</div>
						</td>
						<td>
							<div class="main_tableP3">{{item.data4}}</div>
						</td>
						<td>
							<div class="main_tableP3">{{item.data5}}</div>
						</td>
						<td>
							<div class="main_tableP3">{{item.data6}}</div>
						</td>
					</tr>
				</table>
			</div>
			<div class="main_table">
				<div class="main_label">近三年来本中心人员教研主要成果</div>
				<div class="main_text">
					（1）2022.12 全国仿真创新应用大赛一等奖 何乐民
				</div>
				<div class="main_text">
					（2）2022.09 第五届全国医学影像技术专业青年教师教学创新大赛一等奖
				</div>
				<div class="main_text">
					（3）2022.03 省级教学成果二等奖：王鹏程-新医科视域下医工理交叉融合培养医学影像技术人才的创新与实践
				</div>
				<div class="main_text">
					（4）2022.08 省教学成果二等奖：精准医学时代下“五对接、三融合、四平台”影像技术人才培养模式创新与实践
				</div>
				<div class="main_label">近三年来本中心人员科研主要成果</div>
				<div class="main_text">
					（1）国家自然科学基金委，国家自然科学基金重点项目， 82030082，重塑肿瘤代谢微环境以克服放射免疫治疗抵抗的机制研究， 2021-01至2025-12，在研，主持
				</div>
				<div class="main_text">
					（2）中国工程科技发展战略山东研究院，咨询研究重点项目，202202SDZD02, 山东省医疗器械产业高质量发展战略研究，2022-01至2023-12，在研，主持
				</div>
				<div class="main_text">
					（3）国家自然科学基金委，国家自然科学基金面上项目，82072094，基于人工智能构建MR引导原发性肝癌自适应放疗新策略研究，2021-01-2024-12，在研，主持
				</div>
				<div class="main_text">
					（4）国家自然科学基金委，国家自然科学基金面上项目，82073345，基于影影像和基因组学特征谱的局部晚期非小细胞肺癌个体化放疗研究，2021-01-2024-12，在研，主持
				</div>
				<div class="main_text">
					（5）国家自然科学基金委，国家自然科学基金面上项目，82172865，基于可解释全景深度学习模型的非小细胞肺癌放疗免疫相关肺炎的风险评估，2022-01-2025-12，在研，主持
				</div>
				<div class="main_text">
					（6）国家自然科学基金委，国家自然科学基金面上项目，82172866,EGFR突变肺癌脑转移动态演进的智能异构预测模型研究，2022-01-2025-12，在研，主持
				</div>
				<div class="main_text">
					（7）Chen D, Menon H, Verma V, Seyedin S N, Ajani J A, Hofstetter W L, Nguyen Q N, Chang J Y, Gomez D R, Amini A, Swisher S G, Blum M A, Younes A I, Barsoumian H B, Erasmus J J, Lee J H, Bhutani M S, Hess K R, Minsky B D and Welsh J W. Results of a Phase 1/2 Trial of Chemoradiotherapy With Simultaneous Integrated Boost of Radiotherapy Dose in Unresectable Locally Advanced Esophageal Cancer. JAMA Oncology 2019, 5: 1597-604（期刊论文）
				</div>
				<div class="main_text">
					（8）Theelen W, Chen D, Verma V, Hobbs B P, Peulen H, Aerts J, Bahce I, Niemeijer A, Chang J Y, de Groot P M, Nguyen Q N, Comeaux N I, Simon G R, Skoulidis F, Lin S H, He K, Patel R, Heymach J, Baas P and Welsh J W, Pembrolizumab with or without radiotherapy for metastatic non-small-cell lung cancer: a pooled analysis of two randomised trials. Lancet Respir Med. 2021, 9: 467-75（期刊论文）
				</div>
				<div class="main_text">
					（9）Shen Y, Zhang N, Chai J, Wang T, Ma C, Han L and Yang M. CircPDIA4 Induces Gastric Cancer Progression by Promoting ERK1/2 Activation and Enhancing Biogenesis of Oncogenic circRNAs. 2023, Cancer Rerearch 83: 538-52(期刊论文)
				</div>
				<div class="main_text">
					（10）Liu C, Li X, Huang Q, Zhang M, Lei T, Wang F, Zou W, Huang R, Hu X, Wang C, Zhang X, Sun B, Xing L, Yue J and Yu J.Single-cell RNA-sequencing reveals radiochemotherapy-induced innate immune activation and MHC-II upregulation in cervical cancer. Signal Transduct Target Ther.2023, 8: 44(期刊论文)
				</div>
				<div class="main_text">
					（11）Su T, Zhang N, Wang T, Zeng J, Li W, Han L and Yang M. Super enhancer-regulated lncRNA LINC01089 induces alternative splicing of DIAPH3 to drive hepatocellular carcinoma metastasis.2023, Cancer Research 98: 588-112(期刊论文)
				</div>
				<div class="main_text">
					（12）Lemin He; Weizhao Lu; Zhihong Wang; Shigang Wang; Mei Xue ; CTSim: a numerical simulatorof computed tomography for high-quality radiological education, International Journal of Computer Assisted Radiology and Surgery , 2022, 17(7): 1257-1269 ( 期刊论文)
				</div>
				<div class="main_text">
					（13）Lemin He; Wei Guo; Jianfeng Qiu; Xingwei An; Weizhao Lu ; Altered Spontaneous BrainActivity in Women During Menopause Transition and Its Association With Cognitive Function andSerum Estradiol Level, Frontiers in Endocrinology , 2021, 12(5) ( 期刊论文)
				</div>
				<div class="main_text">
					（14）Gongsen Zhang; Zejun Jiang; Jian Zhu, et al. Innovative integration of augmented reality and optical surface imaging: A coarse-to-precise system for radiotherapy positioning. Medical Physics. 2023;50(7):4505-4520.(期刊论文)
				</div>
				<div class="main_text">
					（15）Gongsen Zhang; Xinchao Liu; Linlin Wang, et al. Development and feasibility evaluation of an AR-assisted radiotherapy positioning system. Frontiers in Oncology. 12:921607.(期刊论文)
				</div>
				<div class="main_text">
					（16）Penghao Gao; Yue Sun; Gongsen Zhang, et al. A transducer positioning method for transcranial focused ultrasound treatment of brain tumors. Frontiers in Neuroscience. 17:1277906.(期刊论文)
				</div>
				<div class="main_label">本实验教学中心队伍培养培训制度措施</div>
				<div class="main_text">
					中心重视实验教学队伍建设，制定相应政策，采取有效措施，鼓励高水平教师投入实验教学工作。建设实验教学与理论教学队伍互通，教学、科研、技术兼容，核心骨干相对稳定，年龄、职称、知识、能力、素质结构合理的实验教学团队。重视实验教学中心主任的选拔和使用，加大人员培养培训力度，拓宽与有关部门、科研院所、行业企业人员交流的途径。形成由学术带头人或高水平教授负责，热爱实验教学，教育理念先进，教学科研能力强，信息技术水平高，实践经验丰富，勇于创新的实验教学队伍。
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				dataList1: [{
					data1: '于金明',
					data2: '65',
					data3: '博士',
					data4: '教授',
					data5: '中心主任',
					data6: '专职',
				}, {
					data1: '王鹏程',
					data2: '59',
					data3: '博士',
					data4: '教授',
					data5: '中心副主任',
					data6: '专职',
				}, {
					data1: '邱建峰',
					data2: '46',
					data3: '博士',
					data4: '教授',
					data5: '中心副主任',
					data6: '专职',
				}, {
					data1: '邢力刚',
					data2: '50',
					data3: '博士',
					data4: '教授',
					data5: '中心副主任',
					data6: '专职',
				}, {
					data1: '尹勇',
					data2: '50',
					data3: '博士',
					data4: '研究院',
					data5: '中心副主任',
					data6: '专职',
				}, {
					data1: '何乐民',
					data2: '46',
					data3: '博士',
					data4: '教授',
					data5: '中心副主任',
					data6: '专职',
				}, {
					data1: '杨明',
					data2: '43',
					data3: '博士',
					data4: '教授',
					data5: '管理',
					data6: '专职',
				}, {
					data1: '陈大卫',
					data2: '33',
					data3: '博士',
					data4: '教授',
					data5: '管理',
					data6: '专职',
				}, {
					data1: '谢丽',
					data2: '45',
					data3: '博士',
					data4: '教授',
					data5: '管理',
					data6: '专职',
				}, {
					data1: '周长春',
					data2: '45',
					data3: '博士',
					data4: '教授',
					data5: '管理',
					data6: '专职',
				}, {
					data1: '吴萌',
					data2: '36',
					data3: '博士',
					data4: '副教授',
					data5: '管理',
					data6: '专职',
				}, {
					data1: '曹允希',
					data2: '59',
					data3: '学士',
					data4: '高级实验师',
					data5: '管理',
					data6: '专职',
				}, {
					data1: '蔡小涛',
					data2: '42',
					data3: '硕士',
					data4: '高级实验师',
					data5: '实验教学',
					data6: '专职',
				}, {
					data1: '李娜',
					data2: '37',
					data3: '博士',
					data4: '实验师',
					data5: '实验教学',
					data6: '专职',
				}, {
					data1: '宋宝',
					data2: '50',
					data3: '博士',
					data4: '副教授',
					data5: '实验教学',
					data6: '专职',
				}, {
					data1: '苑举鹏',
					data2: '35',
					data3: '博士',
					data4: '副教授',
					data5: '实验教学',
					data6: '专职',
				}, {
					data1: '陈云松',
					data2: '39',
					data3: '博士',
					data4: '讲师',
					data5: '实验教学',
					data6: '专职',
				}, {
					data1: '刘文娟',
					data2: '40',
					data3: '博士',
					data4: '讲师',
					data5: '实验教学',
					data6: '专职',
				}, {
					data1: '王飞',
					data2: '39',
					data3: '博士',
					data4: '讲师',
					data5: '实验教学',
					data6: '专职',
				}, {
					data1: '张然',
					data2: '32',
					data3: '博士',
					data4: '讲师',
					data5: '实验教学',
					data6: '专职',
				}, {
					data1: '刘艳丽',
					data2: '46',
					data3: '博士',
					data4: '讲师',
					data5: '实验教学',
					data6: '专职',
				}, {
					data1: '刘兆芸',
					data2: '30',
					data3: '博士',
					data4: '讲师',
					data5: '实验教学',
					data6: '专职',
				}, {
					data1: '霍燕斐',
					data2: '24',
					data3: '博士',
					data4: '讲师',
					data5: '实验教学',
					data6: '专职',
				}, {
					data1: '裴金丽',
					data2: '30',
					data3: '博士',
					data4: '讲师',
					data5: '实验教学',
					data6: '专职',
				}, {
					data1: '王兴武',
					data2: '50',
					data3: '学士',
					data4: '高级实验师',
					data5: '实验教学',
					data6: '专职',
				}, {
					data1: '李洋',
					data2: '36',
					data3: '学士',
					data4: '高级实验师',
					data5: '实验教学',
					data6: '专职',
				}, {
					data1: '韩丰谈',
					data2: '58',
					data3: '学士',
					data4: '教授',
					data5: '实验教学',
					data6: '专职',
				}, {
					data1: '齐现英',
					data2: '49',
					data3: '博士',
					data4: '副教授',
					data5: '实验教学',
					data6: '专职',
				}, {
					data1: '宋莉',
					data2: '45',
					data3: '硕士',
					data4: '副教授',
					data5: '实验教学',
					data6: '专职',
				}, {
					data1: '于广会',
					data2: '48',
					data3: '硕士',
					data4: '副教授',
					data5: '实验教学',
					data6: '专职',
				}, {
					data1: '孙勇',
					data2: '56',
					data3: '硕士',
					data4: '高级实验师',
					data5: '实验教学',
					data6: '专职',
				}, {
					data1: '李正美',
					data2: '44',
					data3: '硕士',
					data4: '讲师',
					data5: '实验教学',
					data6: '专职',
				}, {
					data1: '侯庆锋',
					data2: '46',
					data3: '博士',
					data4: '副教授',
					data5: '实验教学',
					data6: '专职',
				}, {
					data1: '侯立霞',
					data2: '46',
					data3: '博士',
					data4: '副教授',
					data5: '实验教学',
					data6: '专职',
				}, {
					data1: '刘金锋',
					data2: '43',
					data3: '博士',
					data4: '副教授',
					data5: '实验教学',
					data6: '专职',
				}, {
					data1: '赵慧慧',
					data2: '34',
					data3: '硕士',
					data4: '讲师',
					data5: '实验教学',
					data6: '专职',
				}, {
					data1: '窦汝海',
					data2: '46',
					data3: '博士',
					data4: '讲师',
					data5: '实验教学',
					data6: '专职',
				}, {
					data1: '马德鹏',
					data2: '40',
					data3: '博士',
					data4: '讲师',
					data5: '实验教学',
					data6: '专职',
				}, {
					data1: '赵鹏',
					data2: '37',
					data3: '博士',
					data4: '讲师',
					data5: '实验教学',
					data6: '专职',
				}, {
					data1: '吴凉',
					data2: '31',
					data3: '博士',
					data4: '副教授',
					data5: '实验教学',
					data6: '专职',
				}, {
					data1: '李洪龙',
					data2: '31',
					data3: '博士',
					data4: '副教授',
					data5: '实验教学',
					data6: '专职',
				}, {
					data1: '刘艳红',
					data2: '31',
					data3: '博士',
					data4: '副教授',
					data5: '实验教学',
					data6: '专职',
				}, {
					data1: '王琳琳',
					data2: '41',
					data3: '博士',
					data4: '主任医师',
					data5: '实验教学',
					data6: '专职',
				}, {
					data1: '刘建国',
					data2: '42',
					data3: '硕士',
					data4: '高级工程师',
					data5: '技术支持',
					data6: '技术支持',
				}, {
					data1: '黄晓宇',
					data2: '30',
					data3: '硕士',
					data4: '工程师',
					data5: '技术支持',
					data6: '技术支持',
				}, {
					data1: '汪红志',
					data2: '48',
					data3: '博士',
					data4: '高级工程师',
					data5: '技术支持',
					data6: '技术支持',
				}, {
					data1: '夏天',
					data2: '42',
					data3: '博士',
					data4: '高级工程师',
					data5: '技术支持',
					data6: '技术支持',
				}],
			}
		},
		created() {

		},
		mounted() {},
		methods: {},
	}
</script>